import { GaugeChart } from '@silverfort/sf-components';
import { useServiceAccountContext } from '../../contexts/ServiceAccountContext';
import { useCallback, useEffect, useState } from 'react';
import Card from './card';
import { bigNumberToText } from '../../../../../components/utils';

const SMALL_PAGE_SIZE = 1400;

const ServiceAccountsProtected = () => {
    const { insights, isFetchingInsights, setActiveFilters } = useServiceAccountContext();
    const [totalServiceAccounts, setTotalServiceAccounts] = useState(0);
    const [protectedServiceAccounts, setProtectedServiceAccounts] = useState(0);
    const [protectedPercentage, setProtectedPercentage] = useState(0);
    const [chartSize, setChartSize] = useState(180);
    const [lowerThenZero, setLowerThenZero] = useState(false);

    useEffect(() => {
        setTotalServiceAccounts(Number(insights.service_accounts?.count ? insights.service_accounts.count : 0));
        setProtectedServiceAccounts(Number(insights.protected?.count ? insights.protected.count : 0));
    }, [insights]);

    useEffect(() => {
        const percentage = totalServiceAccounts ? (protectedServiceAccounts / totalServiceAccounts) * 100 : 0;
        setProtectedPercentage(0 < percentage && percentage < 1 ? 1 : Math.round(percentage));
        setLowerThenZero(0 < percentage && percentage < 1);
    }, [totalServiceAccounts, protectedServiceAccounts]);

    useEffect(() => {
        if (window.screen.width <= SMALL_PAGE_SIZE) {
            setChartSize(140);
        }
    }, []);

    const updateProtectedFilter = useCallback(
        (isProtected: string) => {
            setActiveFilters((activeFilters) => ({ ...activeFilters, is_protected: [isProtected] }));
        },
        [setActiveFilters]
    );

    return (
        <Card title="Service Accounts Protection">
            <div className="h-full w-full p-4 pr-8 flex items-center justify-center text-sf">
                <GaugeChart
                    label="Active policy"
                    value={protectedPercentage}
                    lowerThen={lowerThenZero}
                    endColor="#ffd7e5"
                    startColor="#ff4d88"
                    isLoading={isFetchingInsights}
                    chartSize={chartSize}
                    mapping={{
                        startMapping: {
                            name: 'Protected',
                            value: bigNumberToText(protectedServiceAccounts),
                            onClick: () => updateProtectedFilter('true')
                        },
                        endMapping: {
                            name: 'Unprotected',
                            value: bigNumberToText(totalServiceAccounts - protectedServiceAccounts),
                            onClick: () => updateProtectedFilter('false')
                        }
                    }}
                />
            </div>
        </Card>
    );
};

export default ServiceAccountsProtected;
